import isFullArray from 'utils/predicates/array/isFullArray.util';

const fromArrayToLength = array => (isFullArray(array) ? array.length : 0);

// noinspection JSUnusedGlobalSymbols
export default fromArrayToLength;
